import details from './details'
import remove from './remove'
import create from './create'
import update from './update'
import assets from './assets'
import template from './template'
import addFloorsSpecificBusinessHour from './addFloorsSpecificBusinessHour'
import removeFloorSpecificBusinessHours from './removeFloorsSpecificBusinessHour'

export default {
  details,
  remove,
  create,
  update,
  assets,
  template,
  addFloorsSpecificBusinessHour,
  removeFloorSpecificBusinessHours,
}
